<template>
  <div class="text-center">
    <p>{{firstAmmount}} 
      <strong class="red-text">
        / 
      </strong>
      {{secondAmmount}}
    </p>
  </div>
</template>

<script>
export default {

  name: 'doubleColumns',

  props: {
    firstAmmount: {
      type: Number
      },
    secondAmmount: {
      type: Number
      },
  },

  data() {
    return {

    };
  },
};
</script>

<style lang="css" scoped>
.red-text{
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/pages/Reports/BudgetReport/DoubleColumns.vue